// extracted by mini-css-extract-plugin
module.exports = {"card":"ArticleCTACard_card__rDUd_","link":"ArticleCTACard_link__F_ddH","heading":"ArticleCTACard_heading__2Bpll","text":"ArticleCTACard_text__4myg0"};